import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import styles from "./OptionSelect.module.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSquareCheck } from "@fortawesome/free-solid-svg-icons";
import { faSquare as faSquareReg } from "@fortawesome/free-regular-svg-icons";

const OptionSelect = ({ onChange, resetFlag }) => {
  const { t } = useTranslation();
  const [options, setOptions] = useState({
    course: "",
    sikyu: false,
    manmo: false,
    echo: false,
  });

  useEffect(() => {
    // resetFlagがtrueになったら、オプションをリセットする
    setOptions({
      course: "",
      sikyu: false,
      manmo: false,
      echo: false,
    });
  }, [resetFlag]);

  const handleInputChange = (e) => {
    const { name, checked, type } = e.target;
    let value = false;
    if (type === "checkbox") {
      value = checked;
    } else if (type === "select-one") {
      value = e.target.value;
    } else {
      if (options.course === e.target.id) {
        value = "";
        e.target.checked = false;
      } else {
        value = e.target.id;
      }
    }
    setOptions((prev) => {
      // 新しい状態を生成
      const newOptions = { ...prev, [name]: value };
      // 非同期に新しい状態を親コンポーネントに渡す
      setTimeout(() => onChange(newOptions), 0);
      return newOptions;
    });
  };

  return (
    <div>
      <div className={styles.options}>
        <div className={styles.optionGroup1}>
          <div className={styles.optionsLabel}>{t("健診コース")}</div>
          <input
            type="radio"
            id="type1"
            name="course"
            checked={options.course === "type1"}
            className={styles.radioInput}
            onChange={handleInputChange}
            onClick={handleInputChange}
          />
          <label htmlFor="type1" className={styles.radioLabel}>
            {t("人間ドック")}
          </label>
          <input
            type="radio"
            id="type2"
            name="course"
            checked={options.course === "type2"}
            className={styles.radioInput}
            onChange={handleInputChange}
            onClick={handleInputChange}
          />
          <label htmlFor="type2" className={styles.radioLabel}>
            {t("東電一般健診")}
          </label>
          <input
            type="radio"
            id="type3"
            name="course"
            checked={options.course === "type3"}
            className={styles.radioInput}
            onChange={handleInputChange}
            onClick={handleInputChange}
          />
          <label htmlFor="type3" className={styles.radioLabel}>
            {t("東電簡易健診健診")}
          </label>
          <input
            type="radio"
            id="type4"
            name="course"
            checked={options.course === "type4"}
            className={styles.radioInput}
            onChange={handleInputChange}
            onClick={handleInputChange}
          />
          <label htmlFor="type4" className={styles.radioLabel}>
            {t("婦人科単独検診")}
          </label>
        </div>
        <div className={styles.optionGroup3}>
          <div className={styles.optionsLabel}>{t("健診コース")}</div>
          <select
            name="course"
            value={options.course}
            onChange={handleInputChange}
            className={styles.selectInput}
          >
            <option value="">{t("指定しない")}</option>
            <option value="type1">{t("人間ドック")}</option>
            <option value="type2">{t("東電一般健診")}</option>
            <option value="type3">{t("東電簡易健診健診")}</option>
            <option value="type4">{t("婦人科単独検診")}</option>
          </select>
        </div>
        <div style={{display: options.course !== "" ? 'block' : 'none'}}>
          <table className={styles.targetMemberTable}>
            <thead>
              <tr>
                <th>被保険者 男性</th>
                <th>被保険者 女性</th>
                <th>被扶養者 男性</th>
                <th>被扶養者 女性</th>
                <th>任継 男性・女性</th>
              </tr>
            </thead>
            <tbody>
              <tr
                style={{
                  display: options.course === "type1" ? "table-row" : "none",
                }}
              >
                <td>○</td>
                <td>○</td>
                <td>○</td>
                <td>○</td>
                <td>○</td>
              </tr>
              <tr
                style={{
                  display: options.course === "type2" ? "table-row" : "none",
                }}
              >

                <td>対象外</td>
                <td>対象外</td>
                <td>○</td>
                <td>○</td>
                <td>○</td>
              </tr>
              <tr
                style={{
                  display: options.course === "type3" ? "table-row" : "none",
                }}
              >
                <td>対象外</td>
                <td>対象外</td>
                <td>○</td>
                <td>○</td>
                <td>○</td>
              </tr>
              <tr
                style={{
                  display: options.course === "type4" ? "table-row" : "none",
                }}
              >
                <td>対象外</td>
                <td>○</td>
                <td>対象外</td>
                <td>対象外</td>
                <td>対象外</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div className={styles.optionGroup2}>
          <label className={styles.optionsLabel}>{t("オプション")}</label>
          <input
            type="checkbox"
            name="sikyu"
            id="sikyu"
            className={styles.checkboxInput}
            onChange={handleInputChange}
          />
          <label htmlFor="sikyu" className={styles.checkboxLabel}>
            <span className={styles.faIcon}>
              <FontAwesomeIcon
                icon={options.sikyu ? faSquareCheck : faSquareReg}
              />
            </span>
            {t("子宮")}
          </label>
          <input
            type="checkbox"
            name="manmo"
            id="manmo"
            className={styles.checkboxInput}
            onChange={handleInputChange}
          />
          <label htmlFor="manmo" className={styles.checkboxLabel}>
            <span className={styles.faIcon}>
              <FontAwesomeIcon
                icon={options.manmo ? faSquareCheck : faSquareReg}
              />
            </span>
            {t("マンモ")}
          </label>
          <input
            type="checkbox"
            name="echo"
            id="echo"
            className={styles.checkboxInput}
            onChange={handleInputChange}
          />
          <label htmlFor="echo" className={styles.checkboxLabel}>
            <span className={styles.faIcon}>
              <FontAwesomeIcon
                icon={options.echo ? faSquareCheck : faSquareReg}
              />
            </span>
            {t("エコー")}
          </label>
        </div>
      </div>
    </div>
  );
};

export default OptionSelect;
